import { API_BASE_URL } from '../config';

const baseUrl= API_BASE_URL;

export const getFaqPageContent = async (lang = "fr") => {
  try {
    const response = await fetch(
      `${baseUrl}pages/faq?lang=${lang === "uk" ? "en" : lang}`
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (err) {
    throw new Error(err.message);
  }
};
